<sb-dialog-header>
  <h1 sb-dialog-title>
    {{ isEditMode ? ('Edit Field' | translate) : ('Create New Field' | translate) }}
  </h1>
</sb-dialog-header>

@if (loading) {
  <sb-loading-state class="size-full" />
} @else {
  <sb-dialog-content>
    <form [formGroup]="form">
      <sb-form-field [label]="'Name' | translate" [control]="form.controls['label']" [errorWhen]="['touched']">
        <input sbInput id="label" formControlName="label" type="text" />
      </sb-form-field>

      <sb-form-field [label]="'Variable' | translate" [control]="form.controls['variable']" [errorWhen]="['touched']">
        <input sbInput id="variable" formControlName="variable" type="text" />
      </sb-form-field>

      <sb-form-field
        [label]="'Description' | translate"
        [control]="form.controls['description']"
        [errorWhen]="['touched']"
      >
        <span ngProjectAs="label-suffix">{{ 'Optional' | translate }}</span>
        <textarea
          sbInput
          id="description"
          formControlName="description"
          rows="3"
          [maxlength]="DESCRIPTION_MAX_LENGTH"
        ></textarea>
      </sb-form-field>

      @if (features.TMP_CUSTOM_QUESTIONS | featureFlag) {
        <div>
          <h3>{{ 'Who fills out this field?' | translate }}</h3>
          <sb-radio-group class="flex flex-col gap-xs" formControlName="internal">
            @for (option of internalOptions; track option.id) {
              <sb-radio [value]="option.id" [label]="option.label | translate" />
            }
          </sb-radio-group>
        </div>
      }
      <sb-form-field [label]="'Type' | translate" [control]="form.controls['type']" [errorWhen]="['touched']">
        <sb-select id="type" formControlName="type" [items]="typeOptions"></sb-select>
      </sb-form-field>

      @if (form.controls['type']?.value === 'select') {
        <sb-form-field [control]="form.controls['options']" [label]="'Options' | translate">
          <fieldset>
            <div>
              @for (option of options; track option) {
                <div>
                  <span>{{ option }}</span>
                  @if (!isEditMode) {
                    <button
                      sb-icon-button
                      [color]="'transparent'"
                      [size]="'sm'"
                      (click)="removeOption(option)"
                      type="button"
                    >
                      <sb-icon name="delete-2-regular" />
                    </button>
                  }
                </div>
              }
            </div>
            <div>
              <input
                sbInput
                [formControl]="optionNameControl"
                [placeholder]="'Add option' | translate"
                (keydown.enter)="addOption()"
              />
              <button sb-icon-button [color]="'primary'" [size]="'sm'" (click)="addOption()" type="button">
                <sb-icon name="plus" />
              </button>
            </div>
          </fieldset>
        </sb-form-field>
      }

      <sb-form-field [label]="'Category' | translate" [control]="form.controls['category']" [errorWhen]="['touched']">
        <sb-select id="category" formControlName="category" [items]="categoryOptions"></sb-select>
      </sb-form-field>
    </form>
  </sb-dialog-content>

  <sb-dialog-footer>
    @if (isEditMode) {
      <sb-dialog-footer-actions [align]="'start'">
        <button sb-button [color]="'outlineRed'" [sbLadda]="deleting" (click)="deleteField()">
          {{ 'Delete' | translate }}
        </button>
      </sb-dialog-footer-actions>
    }
    <sb-dialog-footer-actions [align]="'end'">
      <button
        sb-button
        [color]="'primary'"
        [disabled]="form.invalid || (form.controls['type']?.value === 'select' && options.length === 0)"
        [sbLadda]="loading"
        (click)="save()"
      >
        {{ isEditMode ? ('Save changes' | translate) : ('Create' | translate) }}
      </button>
    </sb-dialog-footer-actions>
  </sb-dialog-footer>
}

<ng-template #deleteConfirmContent>
  @if (templatesUsingField.length > 0) {
    <p class="mb-sm">
      {{
        'These templates still contain "[field]" and will keep using it in hiring processes until you update them:'
          | translate: { field: fieldLabel }
      }}
    </p>
    <ul class="mb-0 max-h-40 list-disc overflow-y-auto pl-4">
      @for (template of templatesUsingField; track template.id) {
        <li>{{ template.title }}</li>
      }
    </ul>
  } @else {
    <p class="mb-0">
      {{
        'Are you sure you want to delete "[field]"? This action cannot be undone.' | translate: { field: fieldLabel }
      }}
    </p>
  }
</ng-template>
